module.exports = __webpack_public_path__ + "static/media/cambiarClave.37fda051.svg";